export const mappingAutocompleteTextFieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        fontSize: "16px",
        minHeight: "56px",
    },
    "& .MuiInputLabel-root": {
        fontSize: "14px",
    },
} as const;

export const mappingReadonlyFieldSx = {
    fontWeight: 600,
    fontSize: "15px",
    fontFamily: '"Nunito", sans-serif',
    color: "#1a1a1a",
    m: 0,
    maxWidth: "100%",
    wordBreak: "break-word" as const,
    textAlign: "center" as const,
};
